export class TabUserIdentifier {
	constructor() {
		this.handleKeyDown = this.handleKeyDown.bind(this);
		this.handleMouseDown = this.handleMouseDown.bind(this);

		document.addEventListener('keydown', this.handleKeyDown);
	}

	private handleKeyDown(event: KeyboardEvent): void {
		if (event.key === 'Tab' || event.keyCode === 9) {
			console.log('Tab user identified');
			document.body.classList.add('tab-user');

			document.removeEventListener('keydown', this.handleKeyDown);
			document.addEventListener('mousedown', this.handleMouseDown);
		}
	}

	private handleMouseDown(): void {
		console.log('Mouse user identified');
		document.body.classList.remove('tab-user');

		document.removeEventListener('mousedown', this.handleMouseDown);
		document.addEventListener('keydown', this.handleKeyDown);
	}
}
